import React, { FunctionComponent } from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { INTERESTS_ID } from './constants'
import { EventSection } from 'src/components/calendar/eventSection'
import { gotoTagSearch } from 'src/lib/navigate-to.js'
import { LoadingContent } from 'src/components/loading-content/LoadingContent'
import { LoadingPlaceholder } from 'src/components/loading-content/LoadingPlaceholder'

const style = require('./Interests.css')
import locale from './locale'

interface Props {
  eventData: any,
  loading: Boolean,
  isEventSet: Boolean,
}

const Placeholder = () => (
  <LoadingPlaceholder modifierClass={style.placeholder}>
    <LoadingContent width="97px" height="25px" borderRadius="rounder" />
    <LoadingPlaceholder modifierClass={style.placeholderContent}>
      <LoadingContent width="56px" height="32px" borderRadius="sharper" />
      <LoadingContent width="84px" height="32px" borderRadius="sharper" />
      <LoadingContent width="95px" height="32px" borderRadius="sharper" />
    </LoadingPlaceholder>
  </LoadingPlaceholder>
)

const InterestsComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  loading,
  eventData,
  isEventSet,
  intl: { formatMessage }
}) => {
  const getAllEventTags = () => {
    var allTags = []
    eventData.allEvents.forEach((event) => allTags.push.apply(allTags, event.tags))
    const uniqueTags = allTags.filter((tag, i) => allTags.findIndex((t) => t.slug === tag.slug) === i)
    return uniqueTags.map((tag, idx) => getTag(tag, idx))
  }

  const getEventTags = (event) => (
    event.tags
    ? event.tags.map((tag, idx) => getTag(tag, idx))
    : null
  )

  const getTag = (tag, idx) => (
    <button className={style.tag} key={idx} onClick={() => gotoTagSearch(tag.slug)}>
      {tag.name.toLowerCase()}
    </button>
  )

  if (loading) return <Placeholder />

  const tags: Array<React.ReactNode> = isEventSet ? getAllEventTags() : getEventTags(eventData)

  return (tags?.length > 0) && (
    <EventSection sectionId={INTERESTS_ID} heading={formatMessage(locale.interests)}>
      <div className={style.container}>
        {tags}
      </div>
    </EventSection>
  )
}

export const Interests = injectIntl(InterestsComponent)
